import { Collapsible, CollapsibleContent } from '@readcloud/ui/collapsible';
import { Progress } from '@readcloud/ui/progress';
import cn from 'classnames';
import * as React from 'react';
import { ReactComponent as Icon } from './icon.svg';

export interface ILoadingIconProps {
  loading: boolean;
  className?: string;
  position?: 'absolute' | 'relative' | 'fixed';
  backdrop?: boolean;
  size?: string;
  progress?: number;
}

const positionMapper: { [index: string]: string } = {
  absolute: 'position-absolute',
  relative: 'position-relatie',
  fixed: 'position-fixed',
};
const sizeMapper: { [index: string]: string } = {
  xs: '20px',
  sm: '50px',
  lg: '120px',
};

export const LoadingIcon: React.FunctionComponent<ILoadingIconProps> = (
  props
) => {
  const [showProgress, setShowProgress] = React.useState<boolean>(false);
  const showProgressRef = React.useRef<number | NodeJS.Timeout | undefined>(
    undefined
  );

  React.useEffect(() => {
    showProgressRef.current = setTimeout(() => setShowProgress(true), 4000);
    return () => clearTimeout(showProgressRef.current as number);
  }, []);

  return (
    <div
      data-testid="loadingIcon"
      className={cn(
        props.className,
        'rc-loading-icon-container',
        'rc-flex',
        'rc-justify-center',
        'rc-items-center',
        props.position && positionMapper[props.position],
        'rc-w-full',
        'rc-h-full'
      )}
    >
      {props.backdrop && (
        <div
          className={cn(
            'rc-absolute',
            'rc-w-full',
            'rc-h-full',
            'rc-bg-dark',
            'rc-rounded',
            'rc-opacity-50',
            '-rc-z-[1]'
          )}
        />
      )}
      <div className={cn('rc-flex rc-flex-col ')}>
        <Icon
          height={props.size ? sizeMapper[props.size] : '80px'}
          width={props.size ? sizeMapper[props.size] : '80px'}
        />

        {props.progress && props.progress >= 0 && (
          <Collapsible open={showProgress}>
            <CollapsibleContent>
              <div>
                <Progress value={props.progress} />
              </div>
            </CollapsibleContent>
          </Collapsible>
        )}
      </div>
    </div>
  );
};
